import { type ErrorComponentProps, Link, useRouter } from "@tanstack/react-router"
import { Compass } from "lucide-react"
import { useTranslation } from "react-i18next"
import { PageContainer } from "@/components/app/page"
import { EmptyState, ErrorState } from "@/components/app/states"
import { Button } from "@/components/ui/button"

/** Default route error boundary. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter()
  return (
    <PageContainer>
      <ErrorState
        error={error}
        onRetry={() => {
          reset()
          void router.invalidate()
        }}
      />
    </PageContainer>
  )
}

export function NotFound() {
  const { t } = useTranslation()
  return (
    <PageContainer className="flex min-h-[60vh] items-center">
      <EmptyState
        size="lg"
        icon={Compass}
        title={t("errors.pageNotFoundTitle")}
        description={t("errors.pageNotFoundDescription")}
        action={<Button render={<Link to="/" />}>{t("errors.backHome")}</Button>}
      />
    </PageContainer>
  )
}
